import { getData } from '../lib'
import { USER_DATA_KEY } from '../utils/constDictionary'
import { createCustomFetch } from './createCustomFetch'

let cachedBaseURL = null
let cachedAt = null
const CACHE_TTL = 1000 * 60 * 60 * 24

export async function getClientCustomFetch() {
  let authToken
  const isClient = typeof window !== 'undefined'
  if (isClient) {
    authToken = document.cookie.match(/auth_token=([^;]+)/)?.[1]
    if (!authToken) {
      const data = getData(USER_DATA_KEY)
      const { accessToken } = data ? JSON.parse(data) : {}
      authToken = accessToken
    }
  } else {
    const { cookies } = await import('next/headers')
    const cookieStore = cookies()
    authToken = cookieStore.get('auth_token')?.value
  }
  const now = Date.now()
  if (!cachedBaseURL || now - cachedAt > CACHE_TTL) {
  const orgRes = await fetch(
    `${process.env.NEXT_PUBLIC_DOMAIN_URL}/api/organization`,
    {
      headers: { Authorization: `Bearer ${authToken || ''}` },
      next: { revalidate: 3600 },
    }
  )

  const { data } = await orgRes.json()
  const { domain, httpsEnabled } = data || {}
  cachedBaseURL = httpsEnabled
    ? `https://${domain}/api`
    : `http://${domain}/api`
  cachedAt = now
  }

  return createCustomFetch({
    baseURL: cachedBaseURL,
    defaultHeaders: {
      Authorization: authToken ? `Bearer ${authToken}` : '',
    },
  })
}
